import { Preview } from "@creatomate/preview";
import { ElementSource, Story, Subtitle } from "chq";
import isSubtitleText from "./isSubtitleText";
import getJsonSubtitleLanguages from "./getJsonSubtitleLanguages";

const activateDefaultLanguage = async (
  preview: Preview, story?: Story
): Promise<ElementSource[]> => {
  const source = preview.getSource();
  const allSubtitles = source.elements.filter((element: ElementSource) => (
    isSubtitleText(element.name)
  ));
  const visibleSubtitles = allSubtitles.filter((subtitle: ElementSource) => (
    subtitle.visible !== false
  ));

  const availableLanguages = getJsonSubtitleLanguages(allSubtitles);
  if (allSubtitles.length > 0 && visibleSubtitles.length === 0) {
    const defaultSubttile = story?.media?.subtitles?.find((subtitle: Subtitle) => (
      subtitle.default
    ));

    const language = defaultSubttile && availableLanguages.includes(defaultSubttile.language)
      ? defaultSubttile.language
      : availableLanguages[0];
    await preview.setSource({
      ...source,
      elements: source.elements.map((element: ElementSource) => {
        if (!isSubtitleText(element.name)) return element;
        const subtitleLanguage = element.name.split("-")[2];
        if (subtitleLanguage === language) {
          return {
            ...element,
            visible: true
          };
        }

        return element;
      })
    });
  }

  return allSubtitles;
};

export default activateDefaultLanguage;
